export default {
  header: 'Hups, jotain odottamatonta tapahtui',
  text: 'Lataa sivu uudelleen tai napsauta alla olevaa ”Palaa ruokalistaan” -painiketta.',
  button: 'Palaa ruokalistaan',
};
